import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import config from '@configFile';
import colors from '@utils/colors';

const Disclaimer = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  return (
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        fontStyle: 'italic',
        fontSize: '11px',
        lineHeight: '15px',
        paddingBottom: '2px',
        color: isDarkMode
          ? colors.disclaimerTextDark
          : colors.disclaimerTextLight
      }}
    >
      {config.disclaimer}
    </Typography>
  );
};

export default Disclaimer;
